export const dummyTagginCompliance = () => {
    return {
        "newfunctionquery2": [
            {
                "count_untagged_resource": "31",
                "tagging_details": "partially_tagged",
                "services": "AmazonRedshift",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "115",
                "tagging_details": "partially_tagged",
                "services": "AmazonCloudWatch",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "106",
                "tagging_details": "partially_tagged",
                "services": "AWSLambda",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "155",
                "tagging_details": "partially_tagged",
                "services": "AmazonLightsail",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "332",
                "tagging_details": "partially_tagged",
                "services": "AmazonSNS",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "2151",
                "tagging_details": "partially_tagged",
                "services": "AWSELB",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "9529",
                "tagging_details": "partially_tagged",
                "services": "AmazonEC2",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "93",
                "tagging_details": "partially_tagged",
                "services": "AmazonES",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "20",
                "tagging_details": "partially_tagged",
                "services": "AmazonCloudFront",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "9165",
                "tagging_details": "partially_tagged",
                "services": "AmazonS3",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "6383",
                "tagging_details": "tagged",
                "services": "AmazonS3",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "117",
                "tagging_details": "tagged",
                "services": "AmazonCloudWatch",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "130",
                "tagging_details": "tagged",
                "services": "AmazonVPC",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "456175",
                "tagging_details": "tagged",
                "services": "AmazonEC2",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "9207",
                "tagging_details": "tagged",
                "services": "AWSELB",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "1911",
                "tagging_details": "Untagged",
                "services": "AmazonCloudWatch",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "156",
                "tagging_details": "Untagged",
                "services": "awswaf",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "187",
                "tagging_details": "Untagged",
                "services": "AWSElasticDisasterRecovery",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "471",
                "tagging_details": "Untagged",
                "services": "AWSSecurityHub",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "4282",
                "tagging_details": "Untagged",
                "services": "AmazonSNS",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "1",
                "tagging_details": "Untagged",
                "services": "AmazonS3GlacierDeepArchive",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "7",
                "tagging_details": "Untagged",
                "services": "ComputeSavingsPlans",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "1039",
                "tagging_details": "Untagged",
                "services": "AWSQueueService",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "1",
                "tagging_details": "Untagged",
                "services": "AmazonRedshift",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "176",
                "tagging_details": "Untagged",
                "services": "AWSLambda",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "1141",
                "tagging_details": "Untagged",
                "services": "AWSCodeArtifact",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "2",
                "tagging_details": "Untagged",
                "services": "AmazonApiGateway",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "161",
                "tagging_details": "Untagged",
                "services": "AWSApplicationMigrationSvc",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "24",
                "tagging_details": "Untagged",
                "services": "AWSCostExplorer",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "96",
                "tagging_details": "Untagged",
                "services": "AWSDirectConnect",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "11026",
                "tagging_details": "Untagged",
                "services": "AmazonS3",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "2",
                "tagging_details": "Untagged",
                "services": "AmazonSES",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "186",
                "tagging_details": "Untagged",
                "services": "AmazonDynamoDB",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "63",
                "tagging_details": "Untagged",
                "services": "AppFlow",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "1652",
                "tagging_details": "Untagged",
                "services": "AWSCloudTrail",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "389734",
                "tagging_details": "Untagged",
                "services": "AmazonEC2",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "95",
                "tagging_details": "Untagged",
                "services": "AmazonES",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "7",
                "tagging_details": "Untagged",
                "services": "AWSDataTransfer",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "111",
                "tagging_details": "Untagged",
                "services": "AWSServiceCatalog",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "1112",
                "tagging_details": "Untagged",
                "services": "AWSSecretsManager",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "64",
                "tagging_details": "Untagged",
                "services": "AWSGlue",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "93",
                "tagging_details": "Untagged",
                "services": "AWSSystemsManager",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "2",
                "tagging_details": "Untagged",
                "services": "AWSDeveloperSupport",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "2",
                "tagging_details": "Untagged",
                "services": "AWSCodeCommit",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "123",
                "tagging_details": "Untagged",
                "services": "AmazonLightsail",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "4226",
                "tagging_details": "Untagged",
                "services": "awskms",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "4",
                "tagging_details": "Untagged",
                "services": "AmazonTextract",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "2465",
                "tagging_details": "Untagged",
                "services": "AWSELB",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "33",
                "tagging_details": "Untagged",
                "services": "AmazonCloudFront",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "5560",
                "tagging_details": "Untagged",
                "services": "AmazonVPC",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "440",
                "tagging_details": "Untagged",
                "services": "AmazonRoute53",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "2",
                "tagging_details": "Untagged",
                "services": "AWSCloudShell",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "471",
                "tagging_details": "Untagged",
                "services": "AmazonGuardDuty",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "335",
                "tagging_details": "Untagged",
                "services": "AmazonRDS",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "173",
                "tagging_details": "Untagged",
                "services": "AWSConfig",
                "__typename": "untagged_resources"
            },
            {
                "count_untagged_resource": "15",
                "tagging_details": "Untagged",
                "services": "AWSSupportBusiness",
                "__typename": "untagged_resources"
            }
        ]
    };
}

export const dummySummaryDashboard = () => {
    return {
        "newfunctionquery3": [
            {
                "reportmonth": "2023-02-01",
                "spend": "18370.67275311483",
                "projected_spend": null,
                "actualspend_previous_month_dif": null,
                "projectedspend_previous_month_diff": null,
                "__typename": "summarydashboard"
            },
            {
                "reportmonth": "2023-01-01",
                "spend": "67184.54111555772",
                "projected_spend": null,
                "actualspend_previous_month_dif": null,
                "projectedspend_previous_month_diff": null,
                "__typename": "summarydashboard"
            },
            {
                "reportmonth": "2022-12-01",
                "spend": "60084.188012599945",
                "projected_spend": null,
                "actualspend_previous_month_dif": null,
                "projectedspend_previous_month_diff": null,
                "__typename": "summarydashboard"
            },
            {
                "reportmonth": "2022-11-01",
                "spend": "40993.18053209782",
                "projected_spend": null,
                "actualspend_previous_month_dif": null,
                "projectedspend_previous_month_diff": null,
                "__typename": "summarydashboard"
            }
        ]
    }
}

export const dummySavingsModel = () => {
    return {
        "newfunctionquery": [
            {
                "account_names": "fs-prod-business",
                "applications": "management",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "148.95263671875",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-common-services",
                "applications": "development",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "0.11206462979316711",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "management",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "19.783681869506836",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "mulesoft",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "364.0244140625",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "BRS",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "117.04640197753906",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Board_meeting",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "315.6708679199219",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "nucleus",
                "environments": "Non-Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "2287.97412109375",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "storage gateway",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "25.725231170654297",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "finnone prod-dr",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "12915.447265625",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "18217.56640625",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "4741.21435546875",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "2937.65283203125",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-common-services",
                "applications": "management",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "154.0052032470703",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fivestar-management",
                "applications": "Untagged",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "50.804847717285156",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Credence",
                "environments": "Non-Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "48.52449035644531",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-common-services",
                "applications": "navision",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "0.38600000739097595",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "board-meeting-software",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "5.35711704287678E-4",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-common-services",
                "applications": "development",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "0.17265184223651886",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "audit-security",
                "applications": "Untagged",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "12.002488136291504",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "881.2699584960938",
                "pricing_model": "Tax",
                "__typename": "savings_model"
            },
            {
                "account_names": "Other",
                "applications": "Untagged",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "10.09999942779541",
                "pricing_model": "Tax",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "navision",
                "environments": "Non-Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "35.943241119384766",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "mulesoft",
                "environments": "Non-Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "668.078857421875",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "2898.29541015625",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "log-archive",
                "applications": "Untagged",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "1.75",
                "pricing_model": "Tax",
                "__typename": "savings_model"
            },
            {
                "account_names": "Other",
                "applications": "Untagged",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "56.14046096801758",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "employee portal",
                "environments": "Non-Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "1343.271728515625",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Non-Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "4133.31689453125",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "management",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "19.75680160522461",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "dedupe",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "1270.040771484375",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "java",
                "environments": "Non-Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "14.791834831237793",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-common-services",
                "applications": "navision",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "0.006129032000899315",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "3756.68994140625",
                "pricing_model": "Tax",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "model building",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "1214.46826171875",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "log-archive",
                "applications": "Untagged",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "9.72750186920166",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "settlement",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "17.60306739807129",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "audit-security",
                "applications": "Untagged",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "2.1500000953674316",
                "pricing_model": "Tax",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "management",
                "environments": "Non-Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "46.25434875488281",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "nach cancellation",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "129.70106506347656",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "navision",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "1805.129638671875",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fivestar-management",
                "applications": "Untagged",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "1500.313720703125",
                "pricing_model": "SavingsPlanRecurringFee",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "dedupe",
                "environments": "Non-Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "127.55634307861328",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "employee portal",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "2594.209716796875",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "2144.3203125",
                "pricing_model": "Tax",
                "__typename": "savings_model"
            },
            {
                "account_names": "fivestar-management",
                "applications": "Untagged",
                "environments": "Untagged",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "0.0",
                "pricing_model": "Tax",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Credence",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "132.74258422851562",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "java",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "10.151403427124023",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "development",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "0.04781876504421234",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "nucleus",
                "environments": "Production",
                "actual_savings": null,
                "potential_savings": null,
                "spend": "5.428021430969238",
                "pricing_model": "Usage",
                "__typename": "savings_model"
            }
        ]
    }
}

export const dummyCredits = () => {
    return {
        "newfunctionquery4": [
            {
                "reportmonth": "2022-11-01",
                "spend": "-37343.691",
                "__typename": "creditchart"
            },
            {
                "reportmonth": "2023-01-01",
                "spend": "-22658.383",
                "__typename": "creditchart"
            },
            {
                "reportmonth": "2023-02-01",
                "spend": "-1",
                "__typename": "creditchart"
            }
        ]
    }
}

export const dummyAssetandSpend = () => {
    return {
        "newfunctionquery": [
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "development",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "0.04781876876950264",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Credence",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "RHEL",
                "infras": "VM",
                "spend": "48.52240753173828",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Credence",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "0.002123513724654913",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "dedupe",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Linux",
                "infras": "VM",
                "spend": "62.560020446777344",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "dedupe",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "12.203798294067383",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "dedupe",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSELB",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "52.79267501831055",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "employee portal",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Windows",
                "infras": "VM",
                "spend": "346.724609375",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "employee portal",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "978.801513671875",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "employee portal",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSELB",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "17.742046356201172",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "java",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Linux",
                "infras": "VM",
                "spend": "12.7425537109375",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "java",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "2.049280881881714",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "management",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Linux",
                "infras": "VM",
                "spend": "36.50558853149414",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "management",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "9.748774528503418",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "mulesoft",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Red Hat Enterprise Linux with HA",
                "infras": "VM",
                "spend": "542.5390625",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "mulesoft",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "72.71747589111328",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "mulesoft",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSELB",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "52.820068359375",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "navision",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Windows",
                "infras": "VM",
                "spend": "0.6634786128997803",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "navision",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "35.2797737121582",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "nucleus",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Linux",
                "infras": "VM",
                "spend": "473.98443603515625",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "nucleus",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Red Hat Enterprise Linux with HA",
                "infras": "VM",
                "spend": "331.9360656738281",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "nucleus",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "1482.05224609375",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonCloudWatch",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "2.7640792541205883E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "RHEL",
                "infras": "VM",
                "spend": "28.610397338867188",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "4039.720703125",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonS3",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "64.96733093261719",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonSNS",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "1.703632005956024E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Non-Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSLambda",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "development",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Linux",
                "infras": "VM",
                "spend": "0.1120000034570694",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "development",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "6.462250166805461E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "management",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Windows",
                "infras": "VM",
                "spend": "1.7319999933242798",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "management",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "9.561339378356934",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "management",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonVPC",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "107.50603485107422",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "management",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSELB",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "35.20587921142578",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "navision",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonCloudWatch",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "navision",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Windows",
                "infras": "VM",
                "spend": "0.38600000739097595",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "navision",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "BRS",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Windows",
                "infras": "VM",
                "spend": "117.04640197753906",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "BRS",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Credence",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Red Hat Enterprise Linux with HA",
                "infras": "VM",
                "spend": "77.32100677490234",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Credence",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "RHEL",
                "infras": "VM",
                "spend": "55.421600341796875",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Credence",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Board_meeting",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonCloudWatch",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "1.4866937398910522",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Board_meeting",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Windows",
                "infras": "VM",
                "spend": "310.92608642578125",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Board_meeting",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "3.2576842308044434",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "board-meeting-software",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonS3",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "5.357113550417125E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "dedupe",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonCloudWatch",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "1.716129183769226",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "dedupe",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Linux",
                "infras": "VM",
                "spend": "1199.5240478515625",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "dedupe",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "15.982931137084961",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "dedupe",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonS3",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "3.8492842577397823E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "dedupe",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSELB",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "52.81669235229492",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "employee portal",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Windows",
                "infras": "VM",
                "spend": "2576.52001953125",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "employee portal",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "1.8599999407342693E-7",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "employee portal",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonS3",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.08317785710096359",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "employee portal",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSELB",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "17.607465744018555",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "finnone prod-dr",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Linux",
                "infras": "VM",
                "spend": "692.1499633789062",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "finnone prod-dr",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Windows",
                "infras": "VM",
                "spend": "0.11741741746664047",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "finnone prod-dr",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "12223.7392578125",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "java",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Linux",
                "infras": "VM",
                "spend": "9.052799224853516",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "java",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "1.0986193418502808",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "management",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonCloudWatch",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "1.5016132593154907",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "management",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Linux",
                "infras": "VM",
                "spend": "3.852473258972168",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "management",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Red Hat Enterprise Linux with HA",
                "infras": "VM",
                "spend": "106.42559051513672",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "management",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "31.78154754638672",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "management",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonS3",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "5.392182350158691",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "model building",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Windows",
                "infras": "VM",
                "spend": "1135.7349853515625",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "model building",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "78.73375701904297",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "mulesoft",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonCloudWatch",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "1.7129039764404297",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "mulesoft",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Red Hat Enterprise Linux with HA",
                "infras": "VM",
                "spend": "288.511962890625",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "mulesoft",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "56.14330291748047",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "mulesoft",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonS3",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "7.999764638952911E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "mulesoft",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSELB",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "17.655418395996094",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "nach cancellation",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Windows",
                "infras": "VM",
                "spend": "102.30397033691406",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "nach cancellation",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "9.753775596618652",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "nach cancellation",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSELB",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "17.643394470214844",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "navision",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Windows",
                "infras": "VM",
                "spend": "1252.6478271484375",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "navision",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "552.4797973632812",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "nucleus",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Linux",
                "infras": "VM",
                "spend": "3.1236555576324463",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "nucleus",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "2.3043630123138428",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "settlement",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSELB",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "17.60306739807129",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "storage gateway",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Linux",
                "infras": "VM",
                "spend": "25.699787139892578",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "storage gateway",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "0.02544393576681614",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonCloudFront",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonCloudWatch",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "4.1937018977478147E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "1614.392333984375",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonES",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "186.7710418701172",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonRedshift",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "875.3649291992188",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonS3",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "9.815027236938477",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonSNS",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "2.3700958990957588E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSELB",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "211.97296142578125",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Production",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSLambda",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "audit-security",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonCloudWatch",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "1.5171213150024414",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "audit-security",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonGuardDuty",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.15154238045215607",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "audit-security",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonS3",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.002053414937108755",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "audit-security",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonSNS",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "6.481748104095459",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "audit-security",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSCloudTrail",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "audit-security",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSConfig",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "1.3330003023147583",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "audit-security",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSDataTransfer",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.009999999776482582",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "audit-security",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "awskms",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "1.170400857925415",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "audit-security",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSLambda",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "audit-security",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSQueueService",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "audit-security",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSSecretsManager",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "6.099999300204217E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "audit-security",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSSecurityHub",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "3.485999345779419",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "audit-security",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSServiceCatalog",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fivestar-management",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonCloudWatch",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "1.3166937828063965",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fivestar-management",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonGuardDuty",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.1335878223180771",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fivestar-management",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonS3",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.6658453345298767",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fivestar-management",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonSNS",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0011766754323616624",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fivestar-management",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSCloudTrail",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fivestar-management",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSConfig",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.020999999716877937",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fivestar-management",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSDataTransfer",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fivestar-management",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSDeveloperSupport",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "45.17820739746094",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fivestar-management",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "awskms",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "7.530011935159564E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fivestar-management",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSQueueService",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fivestar-management",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSSecretsManager",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "6.099999300204217E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fivestar-management",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSSecurityHub",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "3.4870007038116455",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fivestar-management",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSServiceCatalog",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fivestar-management",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "ComputeSavingsPlans",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "1500.313720703125",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "development",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "0.17265184223651886",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "navision",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "0.006129032000899315",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonApiGateway",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "7.000000096013537E-6",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonCloudWatch",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "4.174553871154785",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Linux",
                "infras": "VM",
                "spend": "347.1881103515625",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Windows",
                "infras": "VM",
                "spend": "810.6949462890625",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "416.9026794433594",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonGuardDuty",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "1.7751655578613281",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonRoute53",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "3.386462688446045",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonS3",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "7.344500541687012",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonSNS",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0031858407892286777",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonVPC",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "3312.676025390625",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSCloudTrail",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSCodeArtifact",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSConfig",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "2.830000162124634",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSDataTransfer",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "2.490000009536743",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSDirectConnect",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "173.70005798339844",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSELB",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "6.329999923706055",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "awskms",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.003153011668473482",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSLambda",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSQueueService",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSSecretsManager",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.003255006391555071",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSSecurityHub",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "7.7789998054504395",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSServiceCatalog",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-common-services",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSSupportBusiness",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "525.1947021484375",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "management",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonLightsail",
                "dbaas": "",
                "operating_system": "Linux",
                "infras": "Others",
                "spend": "19.75680160522461",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonCloudFront",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonCloudWatch",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "3.7430765628814697",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Linux",
                "infras": "VM",
                "spend": "16.83326530456543",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Red Hat Enterprise Linux with HA",
                "infras": "VM",
                "spend": "45.590999603271484",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "RHEL",
                "infras": "VM",
                "spend": "28.610397338867188",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Windows",
                "infras": "VM",
                "spend": "123.21749877929688",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "2056.314208984375",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonES",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "47.671810150146484",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonGuardDuty",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "9.042941093444824",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonLightsail",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "7.88999605178833",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonRDS",
                "dbaas": "",
                "operating_system": null,
                "infras": "DB",
                "spend": "178.57015991210938",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonRDS",
                "dbaas": "MYSQL",
                "operating_system": null,
                "infras": "DB",
                "spend": "992.0469970703125",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonRoute53",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.5900000333786011",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonS3",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "11.707813262939453",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonSNS",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.005426593124866486",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonTextract",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonVPC",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "216.2133026123047",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSApplicationMigrationSvc",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSCloudTrail",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSCodeArtifact",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSConfig",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "14.026000022888184",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSDataTransfer",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "2.059999942779541",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSDirectConnect",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.016909152269363403",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSELB",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "64.09698486328125",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "awskms",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.010730990208685398",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSQueueService",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSSecretsManager",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0032000094652175903",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSSecurityHub",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "13.241000175476074",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSServiceCatalog",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSSupportBusiness",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "1250.469970703125",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-non-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSSystemsManager",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "management",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonLightsail",
                "dbaas": "",
                "operating_system": "Linux",
                "infras": "Others",
                "spend": "19.783681869506836",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "management",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonLightsail",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonCloudWatch",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "27.742027282714844",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonDynamoDB",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Linux",
                "infras": "VM",
                "spend": "324.3687744140625",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "RHEL",
                "infras": "VM",
                "spend": "9.812999725341797",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Windows",
                "infras": "VM",
                "spend": "219.42990112304688",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "16655.466796875",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonES",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "33.619998931884766",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonGuardDuty",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "99.6227035522461",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonLightsail",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "29.518959045410156",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonRDS",
                "dbaas": "",
                "operating_system": null,
                "infras": "DB",
                "spend": "0.01727225072681904",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonRDS",
                "dbaas": "MYSQL",
                "operating_system": null,
                "infras": "DB",
                "spend": "0.05925527587532997",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonRedshift",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "157.55999755859375",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonRoute53",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.5900000333786011",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonS3",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "3.351696491241455",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonS3GlacierDeepArchive",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.009999999776482582",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonSES",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "8.5400003513314E-8",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonSNS",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.04975894093513489",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonVPC",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "435.9107666015625",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AppFlow",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "4.265047550201416",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSApplicationMigrationSvc",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "24.039997100830078",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSCloudTrail",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSCodeArtifact",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "1.6000000213622911E-9",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSCodeCommit",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSConfig",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "17.754003524780273",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSCostExplorer",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "1.3699997663497925",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSDataTransfer",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "31.280000686645508",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSDirectConnect",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "77.4096450805664",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSElasticDisasterRecovery",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "145.7097930908203",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSELB",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "60.832340240478516",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSGlue",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "awskms",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "2.5813064575195312",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSLambda",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSQueueService",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSSecretsManager",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.9421756267547607",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSSecurityHub",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "18.509000778198242",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSServiceCatalog",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSSupportBusiness",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "3571.3603515625",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSSystemsManager",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "fs-prod-business",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "awswaf",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "24.503633499145508",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "log-archive",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonCloudWatch",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "1.7064473628997803",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "log-archive",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonGuardDuty",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "2.0538413524627686",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "log-archive",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonS3",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "2.8925998210906982",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "log-archive",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonSNS",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "8.207699283957481E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "log-archive",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSCloudTrail",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "log-archive",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSConfig",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.390999972820282",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "log-archive",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSDataTransfer",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "log-archive",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSGlue",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "log-archive",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "awskms",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "9.540006867609918E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "log-archive",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSLambda",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "log-archive",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSQueueService",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "log-archive",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSSecretsManager",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "6.099999300204217E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "log-archive",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSSecurityHub",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "4.431999683380127",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "log-archive",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSServiceCatalog",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "Other",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonCloudWatch",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.27387094497680664",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "Other",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Linux",
                "infras": "VM",
                "spend": "0.34969377517700195",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "Other",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": "Windows",
                "infras": "VM",
                "spend": "22.77206802368164",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "Other",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonEC2",
                "dbaas": "",
                "operating_system": null,
                "infras": "VM",
                "spend": "12.95767593383789",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "Other",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonRDS",
                "dbaas": "",
                "operating_system": null,
                "infras": "DB",
                "spend": "4.180017948150635",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "Other",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonRDS",
                "dbaas": "MYSQL",
                "operating_system": null,
                "infras": "DB",
                "spend": "23.23557472229004",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "Other",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonS3",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "5.093237268738449E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "Other",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AmazonVPC",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "2.010000705718994",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "Other",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSCloudShell",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "Other",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSCodeCommit",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "Other",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSDataTransfer",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "Other",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "awskms",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "5.400000009103678E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "Other",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSSecurityHub",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.4610000550746918",
                "__typename": "newfunctionapi02"
            },
            {
                "account_names": "Other",
                "applications": "Untagged",
                "environments": "Untagged",
                "all_cloud": "AWS",
                "count": "1",
                "reportmonth": null,
                "services": "AWSServiceCatalog",
                "dbaas": "",
                "operating_system": null,
                "infras": "Others",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            }
        ]
    }
}


export const dummyMonth1records = () => {
    return {
        "newfunctionquery": [
            {
                "applications": "Credence",
                "spend": "9.641599655151367",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Credence",
                "spend": "0.0017534776125103235",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "7.819999694824219",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "1.5254392623901367",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "6.5983052253723145",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "51.8802375793457",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "124.61554718017578",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "2.2128655910491943",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "java",
                "spend": "1.7916017770767212",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "java",
                "spend": "0.25407853722572327",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "4.563199996948242",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "1.2108148336410522",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "67.93280792236328",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "9.0901517868042",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "6.6044793128967285",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "4.420587062835693",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nucleus",
                "spend": "59.24799728393555",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nucleus",
                "spend": "41.49200439453125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nucleus",
                "spend": "160.82601928710938",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "399.248046875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "7.198976039886475",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2.1694000679417513E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "compliance",
                "spend": "34.63999938964844",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "compliance",
                "spend": "8.65380025061313E-6",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "1.6799688339233398",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "15.4399995803833",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "1.0548063516616821",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "13.382002830505371",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "4.399232864379883",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "tableau",
                "spend": "21.837112426757812",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "tableau",
                "spend": "0.0029476513154804707",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "8.045183181762695",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.08297742903232574",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.649318146519363E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3.799999952316284",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "BRS",
                "spend": "23.257600784301758",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "BRS",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Credence",
                "spend": "15.363998413085938",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Credence",
                "spend": "13.763199806213379",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Credence",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "backup_tool_resilio_ecm",
                "spend": "18.31760025024414",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "backup_tool_resilio_ecm",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Board_meeting",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Board_meeting",
                "spend": "61.91600036621094",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Board_meeting",
                "spend": "1.1765518188476562",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "board-meeting-software",
                "spend": "2.4457111067022197E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "brs",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "brs",
                "spend": "13.904000282287598",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "BRS",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "BRS",
                "spend": "2.2751998901367188",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "179.010009765625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "1.9764997959136963",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "2.527260767237749E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "6.6014275550842285",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "314.8705139160156",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "0.0034357826225459576",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "2.200312614440918",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "finnone prod-dr",
                "spend": "84.98271179199219",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "finnone prod-dr",
                "spend": "1801.6412353515625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "java",
                "spend": "1.1315999031066895",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "java",
                "spend": "0.13984163105487823",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "1.4214670658111572",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "3.470400094985962",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "3.965649366378784",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "0.2005792260169983",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "model building",
                "spend": "142.04800415039062",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "model building",
                "spend": "9.68576717376709",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "44.30619812011719",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "7.115586280822754",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "5.0590202590683475E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "2.208254337310791",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nach cancellation",
                "spend": "12.788000106811523",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nach cancellation",
                "spend": "1.2216947078704834",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nach cancellation",
                "spend": "2.20322322845459",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "156.60240173339844",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "69.070556640625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nucleus",
                "spend": "0.2874374985694885",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "settlement",
                "spend": "2.199937582015991",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.09399588406085968",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "23.383106231689453",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "28.559999465942383",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.45043689012527466",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "18.038616180419922",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.11302609741687775",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.018117399886250496",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2.765136305242777E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.2099286317825317",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.1979999989271164",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.16704274713993073",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "7.999999797903001E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.4610000252723694",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.05285102128982544",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.017892200499773026",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.07349748909473419",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.6137570491991937E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.017999999225139618",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.009999999776482582",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "278.8558654785156",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3.300000025774352E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "6.999999459367245E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.47699999809265137",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "9294.43359375",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.06762143224477768",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "-23.517078399658203",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "21.629961013793945",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "31.605392456054688",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.3379210829734802",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.4836411476135254",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.08225373923778534",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "8.164989412762225E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "335.8601989746094",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.812999963760376",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.17000000178813934",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "21.71000099182129",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.7900000214576721",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "4.139997763559222E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "5.799999344162643E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.246000051498413",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "118.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "2.446080207824707",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.08929905295372009",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "-73.42279815673828",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "-124.7887954711914",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "-23.40479850769043",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "-72.98902130126953",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "220.3575897216797",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "5.978553771972656",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.2646225690841675",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.9750000238418579",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "20.680011749267578",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "114.89004516601562",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.5900000333786011",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.302410364151001",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "7.284173625521362E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "32.264251708984375",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.8610000610351562",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.0299999713897705",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.004693547263741493",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "8.844168663024902",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "8.700003963895142E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "5.799998762086034E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.593999981880188",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "118.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "2.446080207824707",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.2476615011692047",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "-266.5457763671875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "-47.77659606933594",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "-18.31760025024414",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "-586.6608276367188",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3798.36962890625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "4.210000038146973",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "12.92271614074707",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3.5659706592559814",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "6.960142612457275",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "20.115209579467773",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "100.62999725341797",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.5900000333786011",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.8398280143737793",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2.006009017350152E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.007694675587117672",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "55.54194641113281",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.4781585931777954",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "4.554000377655029",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "32.38999938964844",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.9199999570846558",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "10.08895492553711",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "18.104001998901367",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "9.479996681213379",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.32713666558265686",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.23840714991092682",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "6.943000316619873",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "619.5796508789062",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3.3554818630218506",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.05838776379823685",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.27502700686454773",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.3831025958061218",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "4.169169915257953E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.06799999624490738",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.1400001676520333E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "7.999999797903001E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.5879999995231628",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "38.02210998535156",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "15.2010498046875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "7.140013694763184",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "39.65090560913086",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.3679999710802804E-7",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "5.370001792907715",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.017000000923871994",
                "__typename": "newfunctionapi02"
            }
        ]
    }
}
export const dummyMonth2records = () => {
    return {
        "newfunctionquery": [
            {
                "applications": "Untagged",
                "spend": "0.04781876504421234",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Credence",
                "spend": "48.52240753173828",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Credence",
                "spend": "0.0021235141903162003",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "62.560020446777344",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "12.203800201416016",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "52.79265213012695",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "346.72503662109375",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "978.8018188476562",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "17.742053985595703",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "java",
                "spend": "12.74255084991455",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "java",
                "spend": "2.0492806434631348",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "36.50558853149414",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "9.748775482177734",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "542.5390625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "72.71753692626953",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "52.82012939453125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "0.6634785532951355",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "35.27976608276367",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nucleus",
                "spend": "473.9844665527344",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nucleus",
                "spend": "331.9360656738281",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nucleus",
                "spend": "1482.0382080078125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2.764078963082284E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "28.610397338867188",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "4039.716796875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "64.96711730957031",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.7036318604368716E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "development",
                "spend": "0.1120000034570694",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "development",
                "spend": "6.462250166805461E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "1.7319999933242798",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "9.561336517333984",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "107.50603485107422",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "35.205902099609375",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "0.38600000739097595",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "BRS",
                "spend": "117.04640197753906",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "BRS",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Credence",
                "spend": "77.32099914550781",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Credence",
                "spend": "55.421600341796875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Credence",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Board_meeting",
                "spend": "1.4866937398910522",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Board_meeting",
                "spend": "310.92608642578125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Board_meeting",
                "spend": "3.2576828002929688",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "board-meeting-software",
                "spend": "5.357114714570343E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "1.7161293029785156",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "1199.5240478515625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "15.982940673828125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "3.8492880412377417E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "52.81666564941406",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "2576.5205078125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "1.8599999407342693E-7",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "0.0831780955195427",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "17.60747528076172",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "finnone prod-dr",
                "spend": "692.1494750976562",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "finnone prod-dr",
                "spend": "0.11741741746664047",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "finnone prod-dr",
                "spend": "12223.8837890625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "java",
                "spend": "9.0527982711792",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "java",
                "spend": "1.0986205339431763",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "1.5016132593154907",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "3.852473258972168",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "106.42559051513672",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "31.781557083129883",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "5.392196178436279",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "model building",
                "spend": "1135.7349853515625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "model building",
                "spend": "78.73381042480469",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "1.7129039764404297",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "288.511962890625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "56.143341064453125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "7.999755907803774E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "17.655420303344727",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nach cancellation",
                "spend": "102.30397033691406",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nach cancellation",
                "spend": "9.75377368927002",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nach cancellation",
                "spend": "17.643400192260742",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "1252.6478271484375",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "552.479248046875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nucleus",
                "spend": "3.1236555576324463",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nucleus",
                "spend": "2.30436372756958",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "settlement",
                "spend": "17.603059768676758",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "storage gateway",
                "spend": "25.699785232543945",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "storage gateway",
                "spend": "0.025443939492106438",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "4.19370160670951E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1614.3836669921875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "186.7709197998047",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "875.364990234375",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "9.81501293182373",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2.3700958990957588E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "211.9734649658203",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.5171215534210205",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.15154238045215607",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0020534151699393988",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "6.481746673583984",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.3329999446868896",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.009999999776482582",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.1704015731811523",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "6.099999300204217E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3.4859988689422607",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.3166942596435547",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.1335877925157547",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.665849506855011",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0011766755487769842",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.020999999716877937",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "45.17820739746094",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "7.530004950240254E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "6.099999300204217E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3.4870007038116455",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1500.313720703125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "development",
                "spend": "0.17265182733535767",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "0.006129032000899315",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "7.000000096013537E-6",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "4.174551486968994",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "347.1882019042969",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "810.6951904296875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "416.9031066894531",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.7751652002334595",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3.3864619731903076",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "7.344507217407227",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0031858389265835285",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3312.679931640625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2.8299999237060547",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2.490000009536743",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "173.70004272460938",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "6.329999923706055",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.003153011202812195",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.003255006391555071",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "7.778999328613281",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "525.1947021484375",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "19.756799697875977",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3.7430756092071533",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "16.83326530456543",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "45.59099578857422",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "28.61039924621582",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "123.21749877929688",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2056.3056640625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "47.671783447265625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "9.042940139770508",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "7.88999605178833",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "178.57008361816406",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "992.0476684570312",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.5900000333786011",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "11.707749366760254",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.005426592659205198",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "216.21290588378906",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "14.026000022888184",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2.059999942779541",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.016909150406718254",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "64.09696197509766",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.010730963200330734",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.003200006205588579",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "13.241000175476074",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1250.469970703125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "19.783681869506836",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "27.742033004760742",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "324.3688659667969",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "9.812999725341797",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "219.42987060546875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "16654.349609375",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "33.619998931884766",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "99.6227035522461",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "29.518959045410156",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.017272237688302994",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.05925527587532997",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "157.55999755859375",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.5900000333786011",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3.3516931533813477",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.009999999776482582",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "8.5400003513314E-8",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.04975894093513489",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "435.90948486328125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "4.265047550201416",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "24.039997100830078",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.6000000213622911E-9",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "17.753999710083008",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.3700000047683716",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "31.280000686645508",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "77.40963745117188",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "145.7096710205078",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "60.83234786987305",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2.581280469894409",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.9421740174293518",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "18.509002685546875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3571.3603515625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "24.50363540649414",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.7064467668533325",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2.0538415908813477",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2.892606258392334",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "8.207699283957481E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.390999972820282",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "9.540013852529228E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "6.099999882280827E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "4.432000160217285",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.27387097477912903",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.34969377517700195",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "22.772069931030273",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "12.95767593383789",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "4.180017948150635",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "23.23557472229004",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "5.09323668666184E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2.0100009441375732",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "5.3999996453057975E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.46100008487701416",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            }
        ]
    }
}

export const dummyMonth3records = () => {
    return {
        "newfunctionquery": [
            {
                "applications": "Untagged",
                "spend": "2.9094996452331543",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "132.72262573242188",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "12.427720069885254",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "53.36348342895508",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "508.88909912109375",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "977.217041015625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "17.853757858276367",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "java",
                "spend": "29.737382888793945",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "java",
                "spend": "2.089623212814331",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "36.90238571166992",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "9.920279502868652",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "613.3659057617188",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "74.13826751708984",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "53.38873291015625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "100.07009887695312",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "36.24225997924805",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nucleus",
                "spend": "478.99346923828125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nucleus",
                "spend": "335.09307861328125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nucleus",
                "spend": "2038.237060546875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "5.897319715586491E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "127.54156494140625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "6574.19873046875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "67.10275268554688",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3.2937001378741115E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "development",
                "spend": "33.7947998046875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "development",
                "spend": "0.02019229345023632",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "56.290000915527344",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "5.125838756561279",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "12.739999771118164",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "3.10871958732605",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "0.20967741310596466",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "12.545000076293945",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "588.0139770507812",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "6.30000016599297E-8",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "1.858064889907837",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "600.8604736328125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "13.536059379577637",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "4.890456330031157E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "dedupe",
                "spend": "53.389251708984375",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "2604.52783203125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "2.2980000835559622E-7",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "0.08004738390445709",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "employee portal",
                "spend": "17.798076629638672",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "finnone",
                "spend": "9.77293586730957",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "finnone prod-dr",
                "spend": "637.0101318359375",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "finnone prod-dr",
                "spend": "8507.7333984375",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "java",
                "spend": "29.173755645751953",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "java",
                "spend": "1.4267075061798096",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "1.622984766960144",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "107.58238983154297",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "32.42037582397461",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "8.691715240478516",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "model building",
                "spend": "861.7297973632812",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "model building",
                "spend": "79.66871643066406",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "1.858064889907837",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "571.96728515625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "57.87379455566406",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "9.572101407684386E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "mulesoft",
                "spend": "17.827312469482422",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nach cancellation",
                "spend": "155.69091796875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nach cancellation",
                "spend": "10.373985290527344",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nach cancellation",
                "spend": "17.834508895874023",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "1550.55517578125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "565.0424194335938",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nucleus",
                "spend": "8.225921630859375",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "nucleus",
                "spend": "2.3682913780212402",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "settlement",
                "spend": "17.796052932739258",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "storage gateway",
                "spend": "148.06602478027344",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "storage gateway",
                "spend": "0.29331812262535095",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3.593292785808444E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "4462.59228515625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "188.8045654296875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "885.1788330078125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "8.330859184265137",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2.523853909224272E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "219.93145751953125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.4182971715927124",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.13974721729755402",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0019292545039206743",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "4.947909355163574",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.2480000257492065",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.009999999776482582",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.0906931161880493",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.1999999696854502E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3.193000555038452",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.4440968036651611",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.15462404489517212",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.5590910315513611",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.001461703795939684",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.1120000034570694",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.029999999329447746",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "34.220001220703125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "4.0499999886378646E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.1999999696854502E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3.818000078201294",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "development",
                "spend": "60.53758239746094",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "navision",
                "spend": "2.2800004482269287",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3.149999974993989E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3.7406764030456543",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "202.9437713623047",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "17.02704620361328",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "330.17840576171875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.5584778785705566",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3.0616228580474854",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2.2500293254852295",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.002802916569635272",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "3350.55859375",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2.5429999828338623",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.5299999713897705",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "161.54005432128906",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "35.51436233520508",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0022560039069503546",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "4.400000034365803E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "6.925000190734863",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "468.3092956542969",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "19.998722076416016",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2.2383041381835938",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "124.24803924560547",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "28.505598068237305",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "11.913084983825684",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1194.0806884765625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "44.20916748046875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "4.969003677368164",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "-2.240000009536743",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "7.9849982261657715",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "74.5901107788086",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "871.311279296875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.5400000214576721",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "5.747096061706543",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.008355194702744484",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "162.78195190429688",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "10.880001068115234",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.7399999499320984",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.004426061175763607",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "49.388668060302734",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.006377972662448883",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "5.200000014156103E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "11.933000564575195",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1309.3953857421875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "19.998722076416016",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "management",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "24.363378524780273",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2069.971923828125",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "73.16333770751953",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "10171.6162109375",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "-3.890000820159912",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "85.69445037841797",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "-8.510000228881836",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "30.021211624145508",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.007514649070799351",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.06123045086860657",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "-18.229995727539062",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.47999998927116394",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "-0.17630989849567413",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.009999999776482582",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "6.009448552504182E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.04593472555279732",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.999999943436137E-9",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "349.0067443847656",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.4152677059173584",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "15.681999206542969",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.0899999141693115",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "-3.9299983978271484",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "58.6204719543457",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "122.25379943847656",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "10.90155029296875",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.18466712534427643",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.9810670614242554",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "4.824000257031003E-7",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.14424312114715576",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "14.946998596191406",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "7.222352027893066",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2947.994384765625",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "20.587064743041992",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.5620476007461548",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.6025617122650146",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "2.310056447982788",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.3228999478087644E-6",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.38799992203712463",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "5.700001493096352E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "1.1999999696854502E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "4.06899881362915",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "applications": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            }
        ]
    }
}

export const dummyMenuList = () => {
    return {
        "newfunctionquery1": [
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "development",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Credence",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": "RHEL",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Credence",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "dedupe",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": "Linux",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "dedupe",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "dedupe",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSELB",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "employee portal",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": "Windows",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "employee portal",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "employee portal",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSELB",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "java",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": "Linux",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "java",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "management",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": "Linux",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "management",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "mulesoft",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": "Red Hat Enterprise Linux with HA",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "mulesoft",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "mulesoft",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSELB",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "navision",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": "Windows",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "navision",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "nucleus",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": "Linux",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "nucleus",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": "Red Hat Enterprise Linux with HA",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "nucleus",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": "RHEL",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonCloudWatch",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonS3",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonSNS",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Non-Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSLambda",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Board_meeting",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Windows",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Board_meeting",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonCloudWatch",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Board_meeting",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "board-meeting-software",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonS3",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "BRS",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Windows",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "BRS",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Credence",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Red Hat Enterprise Linux with HA",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Credence",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "RHEL",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Credence",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "dedupe",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Linux",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "dedupe",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonCloudWatch",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "dedupe",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "dedupe",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonS3",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "dedupe",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSELB",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "development",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Linux",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "development",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "employee portal",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Windows",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "employee portal",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "employee portal",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonS3",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "employee portal",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSELB",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "finnone prod-dr",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Linux",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "finnone prod-dr",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Windows",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "finnone prod-dr",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "java",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Linux",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "java",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "management",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Windows",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "management",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "management",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonVPC",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "management",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSELB",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "management",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Linux",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "management",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Red Hat Enterprise Linux with HA",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "management",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonCloudWatch",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "management",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "management",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonS3",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "model building",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Windows",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "model building",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "mulesoft",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Red Hat Enterprise Linux with HA",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "mulesoft",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonCloudWatch",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "mulesoft",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "mulesoft",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonS3",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "mulesoft",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSELB",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "nach cancellation",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Windows",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "nach cancellation",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "nach cancellation",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSELB",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "navision",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Windows",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "navision",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonCloudWatch",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "navision",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "navision",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Windows",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "navision",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "nucleus",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Linux",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "nucleus",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "settlement",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSELB",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "storage gateway",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": "Linux",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "storage gateway",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonCloudFront",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonCloudWatch",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonES",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonRedshift",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonS3",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonSNS",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSELB",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Production",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSLambda",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "development",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "management",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": "Linux",
                "service": "AmazonLightsail",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "management",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": "Linux",
                "service": "AmazonLightsail",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "management",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonLightsail",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "navision",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "audit-security",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonCloudWatch",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "audit-security",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonGuardDuty",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "audit-security",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonS3",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "audit-security",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonSNS",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "audit-security",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSCloudTrail",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "audit-security",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSConfig",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "audit-security",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSDataTransfer",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "audit-security",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "awskms",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "audit-security",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSLambda",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "audit-security",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSQueueService",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "audit-security",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSSecretsManager",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "audit-security",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSSecurityHub",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "audit-security",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSServiceCatalog",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fivestar-management",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonCloudWatch",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fivestar-management",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonGuardDuty",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fivestar-management",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonS3",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fivestar-management",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonSNS",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fivestar-management",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSCloudTrail",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fivestar-management",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSConfig",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fivestar-management",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSDataTransfer",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fivestar-management",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSDeveloperSupport",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fivestar-management",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "awskms",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fivestar-management",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSQueueService",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fivestar-management",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSSecretsManager",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fivestar-management",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSSecurityHub",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fivestar-management",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSServiceCatalog",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fivestar-management",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "ComputeSavingsPlans",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "VM",
                "os": "Linux",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "VM",
                "os": "Windows",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonApiGateway",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonCloudWatch",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonGuardDuty",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonRoute53",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonS3",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonSNS",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonVPC",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSCloudTrail",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSCodeArtifact",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSConfig",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSDataTransfer",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSDirectConnect",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSELB",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "awskms",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSLambda",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSQueueService",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSSecretsManager",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSSecurityHub",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSServiceCatalog",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-common-services",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSSupportBusiness",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "VM",
                "os": "Linux",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "VM",
                "os": "Red Hat Enterprise Linux with HA",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "VM",
                "os": "RHEL",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "VM",
                "os": "Windows",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonCloudFront",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonCloudWatch",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonES",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonGuardDuty",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonLightsail",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "DB",
                "os": null,
                "service": "AmazonRDS",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonRoute53",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonS3",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonSNS",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonTextract",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonVPC",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSApplicationMigrationSvc",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSCloudTrail",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSCodeArtifact",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSConfig",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSDataTransfer",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSDirectConnect",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSELB",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "awskms",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSQueueService",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSSecretsManager",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSSecurityHub",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSServiceCatalog",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSSupportBusiness",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSSystemsManager",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-non-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "MYSQL",
                "infra": "DB",
                "os": null,
                "service": "AmazonRDS",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "VM",
                "os": "Linux",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "VM",
                "os": "RHEL",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "VM",
                "os": "Windows",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonCloudWatch",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonDynamoDB",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonES",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonGuardDuty",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonLightsail",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "DB",
                "os": null,
                "service": "AmazonRDS",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonRedshift",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonRoute53",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonS3",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonS3GlacierDeepArchive",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonSES",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonSNS",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonVPC",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AppFlow",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSApplicationMigrationSvc",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSCloudTrail",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSCodeArtifact",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSCodeCommit",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSConfig",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSCostExplorer",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSDataTransfer",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSDirectConnect",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSElasticDisasterRecovery",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSELB",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSGlue",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "awskms",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSLambda",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSQueueService",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSSecretsManager",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSSecurityHub",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSServiceCatalog",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSSupportBusiness",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSSystemsManager",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "awswaf",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "fs-prod-business",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "MYSQL",
                "infra": "DB",
                "os": null,
                "service": "AmazonRDS",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "log-archive",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonCloudWatch",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "log-archive",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonGuardDuty",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "log-archive",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonS3",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "log-archive",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonSNS",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "log-archive",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSCloudTrail",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "log-archive",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSConfig",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "log-archive",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSDataTransfer",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "log-archive",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSGlue",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "log-archive",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "awskms",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "log-archive",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSLambda",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "log-archive",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSQueueService",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "log-archive",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSSecretsManager",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "log-archive",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSSecurityHub",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "log-archive",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSServiceCatalog",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "Other",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "VM",
                "os": "Linux",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "Other",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "VM",
                "os": "Windows",
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "Other",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonCloudWatch",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "Other",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "VM",
                "os": null,
                "service": "AmazonEC2",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "Other",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "DB",
                "os": null,
                "service": "AmazonRDS",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "Other",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonS3",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "Other",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AmazonVPC",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "Other",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSCloudShell",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "Other",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSCodeCommit",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "Other",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSDataTransfer",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "Other",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "awskms",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "Other",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSSecurityHub",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "Other",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "",
                "infra": "Others",
                "os": null,
                "service": "AWSServiceCatalog",
                "__typename": "all_dropdown"
            },
            {
                "account_name": "Other",
                "application": "Untagged",
                "cloud": "AWS",
                "environment": "Untagged",
                "db": "MYSQL",
                "infra": "DB",
                "os": null,
                "service": "AmazonRDS",
                "__typename": "all_dropdown"
            }
        ]
    }
}

export const dummyEnvironmentSpend = () => {
    return {
        "newfunctionquery": [
            {
                "environments": "development",
                "spend": "0.04781876504421234",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "48.52240753173828",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "0.002123514423146844",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "62.560020446777344",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "12.203798294067383",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "52.79268264770508",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "346.72503662109375",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "978.8055419921875",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "17.742050170898438",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "12.742551803588867",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "2.0492806434631348",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "36.50558853149414",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "9.748773574829102",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "542.5390625",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "72.71753692626953",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "52.820098876953125",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "0.6634786128997803",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "35.279788970947266",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "473.98443603515625",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "331.9360656738281",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "1482.048828125",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "2.764078963082284E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "28.610397338867188",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "4039.73681640625",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "64.96715545654297",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "1.7036318604368716E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Non-Production",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "0.1120000034570694",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "6.462250166805461E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "1.7319999933242798",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "9.5613431930542",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "107.50603485107422",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "35.20588684082031",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "0.38600000739097595",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "117.04640197753906",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "77.32100677490234",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "55.421600341796875",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "1.4866937398910522",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "310.92608642578125",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "3.257683515548706",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "5.357121699489653E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "1.716129183769226",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "1199.5240478515625",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "15.982930183410645",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "3.8492787280119956E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "52.81663131713867",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "2576.518798828125",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "1.8599999407342693E-7",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "0.08317793160676956",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "17.607479095458984",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "692.1494750976562",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "0.11741741746664047",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "12223.224609375",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "9.052799224853516",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "1.0986186265945435",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "1.5016132593154907",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "3.852473258972168",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "106.42559051513672",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "31.781518936157227",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "5.392177104949951",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "1135.735107421875",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "78.73373413085938",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "1.7129039764404297",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "288.5119323730469",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "56.14335250854492",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "7.999757071956992E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "17.655414581298828",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "102.30397033691406",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "9.753776550292969",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "17.643390655517578",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "1252.647705078125",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "552.4801635742188",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "3.1236555576324463",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "2.3043630123138428",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "17.603057861328125",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "25.699785232543945",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "0.02544393762946129",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "4.193702188786119E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "1614.3863525390625",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "186.77105712890625",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "875.3649291992188",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "9.814974784851074",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "2.370096044614911E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "211.9736785888672",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Production",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "1.5171211957931519",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.15154236555099487",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.002053419593721628",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "6.481749534606934",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "1.3329999446868896",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.009999999776482582",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "1.1703970432281494",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "6.099999882280827E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "3.4859988689422607",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "1.3166944980621338",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.1335877925157547",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.6658503413200378",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0011766754323616624",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.020999999716877937",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "45.17820739746094",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "7.530002039857209E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "6.099999882280827E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "3.4870007038116455",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "1500.3135986328125",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.17265182733535767",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.006129032000899315",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "7.000000096013537E-6",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "4.174550533294678",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "347.1881103515625",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "810.6950073242188",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "416.9027404785156",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "1.7751655578613281",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "3.386462450027466",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "7.344507694244385",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.003185841254889965",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "3312.6748046875",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "2.8299996852874756",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "2.490000009536743",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "173.70005798339844",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "6.329999923706055",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0031530135311186314",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.003255006391555071",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "7.7789998054504395",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "525.1947021484375",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "19.75680160522461",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "3.743077516555786",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "16.83326530456543",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "45.59099578857422",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "28.610397338867188",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "123.21749877929688",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "2056.30712890625",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "47.6717643737793",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "9.042937278747559",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "7.88999605178833",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "178.57015991210938",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "992.0474853515625",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.5900000333786011",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "11.70776653289795",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.005426595453172922",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "216.2129669189453",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "14.026000022888184",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "2.059999942779541",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.016909150406718254",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "64.09697723388672",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.010730981826782227",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.003200006205588579",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "13.240999221801758",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "1250.469970703125",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "19.783679962158203",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "27.742036819458008",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "324.368896484375",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "9.812999725341797",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "219.42990112304688",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "16656.84375",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "33.619998931884766",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "99.62269592285156",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "29.518959045410156",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.01727225072681904",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.05925527587532997",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "157.55999755859375",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.5900000333786011",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "3.3516950607299805",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.009999999776482582",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "8.5400003513314E-8",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.04975894093513489",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "435.9098205566406",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "4.265047073364258",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "24.039997100830078",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "1.6000000213622911E-9",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "17.75400161743164",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "1.369999885559082",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "31.280000686645508",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "77.4096450805664",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "145.7097930908203",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "60.83234786987305",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "2.58127498626709",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.9421735405921936",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "18.509000778198242",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "3571.3603515625",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "24.50362205505371",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "1.7064467668533325",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "2.0538413524627686",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "2.892608880996704",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "8.207699283957481E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.390999972820282",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "9.540008613839746E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "6.099999882280827E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "4.432000160217285",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.27387094497680664",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.34969377517700195",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "22.772069931030273",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "12.95767593383789",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "4.180017948150635",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "23.23557472229004",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "5.09323668666184E-4",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "2.010000705718994",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "5.400000372901559E-5",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.4610000550746918",
                "__typename": "newfunctionapi02"
            },
            {
                "environments": "Untagged",
                "spend": "0.0",
                "__typename": "newfunctionapi02"
            }
        ]
    }
}